var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger-v4';
import { Expose } from 'class-transformer';
import { TemplateExposeGroup } from '../interface';
export class ReadTemplateWorkflowInputFieldDto {
}
__decorate([
    ApiProperty({ example: 'emailSubject', type: () => String }),
    Expose({ groups: [TemplateExposeGroup.MODEL, TemplateExposeGroup.READ, TemplateExposeGroup.CONFIG] }),
    __metadata("design:type", String)
], ReadTemplateWorkflowInputFieldDto.prototype, "name", void 0);
__decorate([
    ApiPropertyOptional({ oneOf: [{ type: 'string' }, { type: 'number' }], example: '10', nullable: true }),
    Expose({ groups: [TemplateExposeGroup.MODEL, TemplateExposeGroup.READ, TemplateExposeGroup.CONFIG] }),
    __metadata("design:type", Object)
], ReadTemplateWorkflowInputFieldDto.prototype, "value", void 0);
__decorate([
    ApiProperty({ type: () => Boolean }),
    Expose({ groups: [TemplateExposeGroup.MODEL, TemplateExposeGroup.READ] }),
    __metadata("design:type", Boolean)
], ReadTemplateWorkflowInputFieldDto.prototype, "editable", void 0);
//# sourceMappingURL=ReadTemplateWorkflowInputFieldDto.js.map